import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/** Garante que cada navegação de rota comece no topo da página. */
const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

export default ScrollToTop
